import { css } from '@emotion/react'
import { fonts } from '@opallabs/pulsar'
import { colors } from '@opallabs/spectrum'

export const base = css({
  alignItems: 'center',
  backgroundColor: colors.n2.base,
  boxSizing: 'border-box',
  display: 'flex',
  fontFamily: fonts.proxima,
  justifyContent: 'space-between',
  padding: '9px 14px',
  width: 260,
  '&:hover': {
    cursor: 'pointer',
  },
})
